import { PROD_CDN_PORT, STAGE_CDN_PORT } from 'src/api/constants';
import {
  getEnvVariable,
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT
} from './envVariablesHelper';

export const getCDNStaticSourceURl = (env: string): string => {
  const currentEnv = env || getEnvVariable(NEXT_PUBLIC_ENV);

  switch (currentEnv) {
    case NEXT_PUBLIC_ENV_VARIANT.PROD:
      return PROD_CDN_PORT;
    case NEXT_PUBLIC_ENV_VARIANT.STAGE:
      return STAGE_CDN_PORT;
    case NEXT_PUBLIC_ENV_VARIANT.DEV:
    default:
      return '/';
  }
};

export const getCDNAssetPrefix = () => {
  const currentEnv = getEnvVariable(NEXT_PUBLIC_ENV);

  if (currentEnv === NEXT_PUBLIC_ENV_VARIANT.PROD) {
    return 'https://spaces.likie.ua';
  }
  if (currentEnv === NEXT_PUBLIC_ENV_VARIANT.STAGE) {
    return 'https://spaces.likie.dp.ua';
  }
  // Use the CDN in production and localhost for development.
  return undefined;
};

export const getCDNDoctorImageURL = (
  id: string,
  format?: 'webp' | 'png'
): string => {
  return `${PROD_CDN_PORT}doctor_reviewer/${id}.${format || 'png'}`;
};

export const getCDNDrugImageURL = (
  id: string,
  size: 'S' | 'M' | 'L',
  format?: 'webp' | 'png'
): string => {
  return `${PROD_CDN_PORT}drug/image/${size}/${id}.${format || 'webp'}`;
};

export const getCDNStaticImageURL = (
  imageSrc: string,
  currentEnv?: string
): string => {
  const PORT = getCDNStaticSourceURl(currentEnv);
  return `${PORT}static/images/${imageSrc}`;
};
